import Player from '@/components/VideoPlayer/index'

export default { Player }
